import { render, staticRenderFns } from "./PreLink.vue?vue&type=template&id=cec7a74c&scoped=true&"
import script from "./PreLink.vue?vue&type=script&lang=js&"
export * from "./PreLink.vue?vue&type=script&lang=js&"
import style0 from "./PreLink.vue?vue&type=style&index=0&id=cec7a74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec7a74c",
  null
  
)

export default component.exports